import React from 'react';
import { useFormik } from 'formik';
import cn from 'classnames';

import Modal from '../../../common/ui/Modal';
import { requiredValidationHelper, isValidPhone, invalidPhoneMsg } from '../../../../utils/validations';
import AddressForm from './AddressForm';
import { useGetAddressByIdQuery } from '../../../../redux/addressesApi';
import ArrowIcon from '../../../../assets/icons/common/ArrowIcon';
import { getStateCode } from '../../../../utils/helpers';

import styles from './styles.module.scss';

const SelectAddressCancellationModal = ({
  addressId,
  submitHandler,
  isOpen,
  onClose,
  backHandler,
}) => {
  const { data: address } = useGetAddressByIdQuery(addressId);

  const handleUpdateAddress = (data) => {
    submitHandler(data);
  };

  const validate = (values) => {
    let errors = {};
    const requiredFields = [
      'first_name',
      'last_name',
      'address1',
      'city',
      'province',
      'zip',
      'phone',
    ];

    requiredValidationHelper(values, errors, requiredFields);

    if (values.phone && !isValidPhone(values.phone)) {
      errors.phone = invalidPhoneMsg;
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      address1: address?.address1 || '',
      address2: address?.address2 || '',
      city: address?.city || '',
      province: getStateCode(address?.province) || '',
      zip: address?.zip || '',
      first_name: address?.first_name || '',
      last_name: address?.last_name || '',
      phone: address?.phone || '',
    },
    enableReinitialize: true,
    onSubmit: handleUpdateAddress,
    validate,
  });

  return (
    <Modal
      preventClosing={true}
      isOpen={isOpen}
      onClose={onClose}
      className={styles.addressModal}
      showSupportFooter={true}
    >
      <div className={styles.headerWrapper}>
        <button className={styles.backButton} onClick={backHandler}>
          <ArrowIcon />
        </button>
        <div>
          <h3 className={cn('h3', styles.title)}>
            Please Confirm Your Address
          </h3>
          <p>
            Please verify that your address is correct. We'll use this
            information to generate your return label.
          </p>
        </div>
      </div>
      <AddressForm address={address} formik={formik} />
    </Modal>
  );
};

export default SelectAddressCancellationModal;
